import { useMsal } from '@azure/msal-react'
import { useDispatch, useSelector } from 'react-redux'
import axios, { AxiosRequestConfig } from 'axios'
import { IUser } from '../interface/IUser'
import { setUser } from '../source/slice/UserSlice'
import { baseApi } from '../api/BaseApi'
import { setRequireCalendarReload } from '../source/slice/LoadingDateSlice'
import { InteractionRequiredAuthError } from '@azure/msal-browser'

const scope: string = process.env.REACT_APP_SCOPE || ''

export const useRefreshUser = () => {
    const { instance, accounts } = useMsal()
    const dispatch = useDispatch()
    const currentPersonnelNumber = useSelector((state: any) => state.user?.value?.worker?.mserp_personnelnumber as string | undefined)

    const refreshUser = async (): Promise<void> => {
        if (!accounts?.[0]) return
        try {
            const tokenResult = await instance.acquireTokenSilent({
                account: accounts[0],
                scopes: [scope],
                forceRefresh: false,
            })

            const config: AxiosRequestConfig = {
                headers: { Authorization: `Bearer ${tokenResult.accessToken}` },
                data: {},
                params: {},
            }

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/User`, config)

            const tokenRoles = Array.isArray((tokenResult.idTokenClaims as any)?.roles)
                ? ((tokenResult.idTokenClaims as any).roles as string[])
                : []

            const newUser: IUser = {
                userid: accounts[0]?.username,
                token: tokenResult.accessToken,
                worker: response.data?.worker,
                resource: response.data?.resource,
                isSeniorManager: response.data?.isSeniorManager || false,
                isPM: tokenRoles.includes('Projectmanager'),
                isAdmin: tokenRoles.includes('Admin'),
                isWorkingStudent: response.data?.isWorkingStudent || false,
            }

            dispatch(setUser(newUser))
            dispatch(baseApi.util.resetApiState())

            if (currentPersonnelNumber !== undefined &&
                currentPersonnelNumber !== newUser.worker?.mserp_personnelnumber) {
                dispatch(setRequireCalendarReload(true))
            }
        } catch (error: any) {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect({ scopes: [scope], account: accounts[0] })
            }
            console.log(error)
        }
    }

    return { refreshUser }
}
